import axios from 'axios'
import { stopSubmit } from 'redux-form'
import * as types from '../constants/actionTypes'
import { hideModal } from './modalsActions'

export const showCreateTicket = () => {
  return {
    type: types.ShowCreateTicket,
  }
}

export const submitCreateTicketFailure = (error) => ({
  type: types.SubmitCreateTicketFailure,
  error,
})

export const submitCreateTicket = (currentConv, ticket) => {
  return (dispatch) => {
    // FIXME: shall we dispatch something here? like in submitLogin dispatching  dispatch(requestSession());

    let description: string | null = null
    if (ticket.description.indexOf('Created in admin chat: ') === -1) {
      description = `${
        ticket.description
      }\n\nCreated in admin chat: ${window.location.toString()}`
    } else {
      description = ticket.description
    }

    const client = currentConv.conversation.user
    return axios
      .post(`${process.env.REACT_APP_BLINKER_API_URL}/api/v3/admin/tickets`, {
        status: 'new',
        subject: ticket.subject,
        description,
        user_id: client.id,
        requester_name: client.name,
        requester_email: client.email,
      })
      .then(() => {
        dispatch(hideModal())
      })
      .catch((error) => {
        const errorMesssage =
          error.response && error.response.data
            ? error.response.data.message
            : 'Something went wrong'
        dispatch(stopSubmit('createTicketForm', { description: errorMesssage }))
        dispatch(submitCreateTicketFailure(error))
      })
  }
}
